import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ContentBlock } from '../../models';
import { Case } from '../../models/case.model';
import { ContentBlockBaseComponent } from '../content-block-base/content-block-base.component';

@Component({
  selector: 'app-content-block-case',
  templateUrl: './content-block-case.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentBlockCaseComponent extends ContentBlockBaseComponent {
  getRandomArbitrary(min: number, max: number) {
    return Math.random() * (max - min) + min;
  }

  getRandomSpeed(i: number) {
    const random = this.getRandomArbitrary(0.02, 0.1);
    return 1 + random;
  }

  trackByFn(index: number, block: Case) {
    return block.id;
  }
}
